var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-card',{staticClass:"card-register-form"},[_c('h3',[_vm._v("Личный кабинет абитуриента "),_c('span',[_vm._v("НИУ ВШЭ")])]),_vm._v(" "),_c('registerButtons')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }